export const FETCH_USERS = 'FETCH_USERS';
export const GOT_RESPONSE = 'GOT_RESPONSE';
export const ERROR = 'ERROR';
export const CREATE_USERS = 'CREATE_USERS';
